import './pageHeaderRight.scss';
import React from 'react';
import { isEnterprise } from '../../utils/util';
import If from '../../common/components/if';
import { AppContext } from '../../context/appContext';
import { PlainText } from '../plainText/plainText';
import { useState, useContext, useEffect } from 'react';
import { getCurrent, getMsgCnt } from '../../common/utils/util';
import { USEQuery } from '@umu/umu-util';
import { LoginCard } from '../../components/loginCard/loginCard';
import { DropDown } from '../../common/components/dropDown/dropDown';
import { LoginState } from '../../components/loginState/loginState';
import { getUnReadCount } from '../../dataServices/msgCenterDataService';
import { getEnterpriseInfo } from '../../dataServices/getEnterpriseInfo';
import { EnterpriseCountdownNavItem } from '../../components/enterpriseCountdownNavItem/enterpriseCountdownNavItem';

import { VERSION_TYPE, IAccountPlan } from '../../interface/plan';

export interface IState {
    msgCnt: number;
    planId: number;
}

interface IProps {
    accountPlan: IAccountPlan;
}

export const PageHeaderRight = ({ accountPlan }: IProps) => {
    const appContext = useContext(AppContext);
    const { enterpriseInfo, isCAdministrator, msgCnt: incomeCnt = 0, isInUSE = false } = appContext.state;
    const [msgCnt, setMsgCnt] = useState(0);
    const versionType = accountPlan.teacher_status;
    const enterpriseAccountType = Number(enterpriseInfo.role_type);
    const isEnterpriseAccount = isEnterprise(enterpriseInfo.enterprise_id);
    const [isDepartmentManager, setIsDepartmentManager] = useState(false);
    const isEnterpriseManage = isEnterpriseAccount && enterpriseAccountType >= 3;
    const isEnterpriseAdmin = isEnterpriseAccount && enterpriseAccountType >= 4;

    const getEnterprise = async () => {
        if (!isEnterpriseAccount) {
            return;
        }
        const res = await getEnterpriseInfo();
        if (!res.error_code && res.data) {
            setIsDepartmentManager(res.data.permission.is_department_manager === 1);
        }
    };

    useEffect(() => {
        const load = () => {
            if (!incomeCnt) {
                getUnReadCount({}).then((ret) => {
                    setMsgCnt(ret?.data?.total_num || 0);
                });
            }
            getEnterprise();
        };
        load();
    }, []);

    const cnt = getMsgCnt(incomeCnt || msgCnt);
    const isInstitute = versionType === VERSION_TYPE.INSTITUTE || versionType === VERSION_TYPE.INSTITUTE_COMMON;
    const domain = (window as any)?.pageData?.config?.site_host || location.hostname;

    return (
        <div className="nav-header-right">
            <EnterpriseCountdownNavItem isAdmin={isEnterpriseAdmin} accountPlan={accountPlan} />
            <If condition={!isInUSE && (isEnterpriseManage || isCAdministrator || isDepartmentManager)}>
                <li className="page-header-nav-item to-platform-manage">
                    <a
                        href={`//${domain}/platformManage/index`}
                        className={getCurrent('platformManage') ? 'btn trackEvent current' : 'btn trackEvent'}
                    >
                        <If condition={!isInstitute}>
                            <PlainText>管理后台</PlainText>
                        </If>
                        <If condition={isInstitute}>
                            <PlainText>机构后台</PlainText>
                        </If>
                    </a>
                </li>
            </If>
            <li className="page-header-nav-item header-nav-msg">
                <a
                    className={getCurrent('message') ? 'btn trackEvent current' : 'btn trackEvent'}
                    href={isInUSE ? `/message?${USEQuery}=1&headerType=2` : '/message'}
                >
                    <If condition={!!cnt}>
                        <span className="msg-cnt">{cnt}</span>
                    </If>
                    <div className="icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M19.5 17.5692V11.0717C19.5 7.43424 17.4622 4.38905 13.8744 3.5829V2.7779C13.8755 1.7935 13.0378 1 12 1C10.9622 1 10.1244 1.7935 10.1244 2.77675V3.5829C6.55 4.3879 4.5 7.42161 4.5 11.0717V17.5692L2 19.3655V20.55H22V19.3655L19.5 17.5692ZM11.9102 23.9992C13.659 23.9992 15.1301 22.8492 15.1301 21.6992H8.66797C8.66797 22.8492 10.1613 23.9992 11.9102 23.9992ZM6.73047 18.2516H17.2505V11.0227C17.2505 8.03496 15.0872 5.60156 12.0005 5.60156C8.9138 5.60156 6.73047 8.03496 6.73047 11.0227V18.2516Z"
                            />
                        </svg>
                    </div>
                </a>
            </li>
            <DropDown isInUSE={isInUSE} content={<LoginState />}>
                <LoginCard />
            </DropDown>
        </div>
    );
};
